import api from 'services/api';
import {
  IGetFilesResponse,
  IParamsPatchFiles,
  IPostFilesPayload,
} from './types';

export const FilesServices = {
  postFiles: async (payload: IPostFilesPayload) => {
    const { formData } = payload;
    const response = await api.post('/files', formData);
    return response.data;
  },
  patchFiles: async (params: IParamsPatchFiles) => {
    const { id, payload } = params;
    const response = await api.patch(`/files/${id}`, payload);
    return response.data;
  },
  deleteFiles: async (id: string) => {
    const response = await api.delete(`/files/${id}`);
    return response.data;
  },
  getFiles: async () => {
    const response = await api.get<IGetFilesResponse>(`/files`);
    return response.data;
  },
};
